import { Component, OnInit } from '@angular/core';
import { SessionManagerService } from 'src/app/services/session-manager/session-manager.service';
import { StructureHelperService } from 'src/app/services/structure/structure-helper.service';
import { StructureService } from 'src/app/services/structure/structure.service';

@Component({
  selector: 'app-main',
  standalone: true
})
export class MainComponent implements OnInit {

  constructor(
    private sessionManager: SessionManagerService,
    private structure: StructureService,
    private structureHelper: StructureHelperService
  ) {
  }

  ngOnInit() {
    this.sessionManager.checkSession();
    this.structure.buildLobby();
    this.structureHelper.loadAllGames();
  }

}
